import { render, staticRenderFns } from "./dataDetail.vue?vue&type=template&id=07cf3d01&scoped=true&"
import script from "./dataDetail.vue?vue&type=script&lang=js&"
export * from "./dataDetail.vue?vue&type=script&lang=js&"
import style0 from "./dataDetail.vue?vue&type=style&index=0&id=07cf3d01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf3d01",
  null
  
)

export default component.exports